import { V5BaseModel, V5BaseModelParams } from '@journeyapps-platform/lib-journey-core';
import { MFAFactor, UserMFAFactorResource } from '@journeyapps-platform/types-accounts-hub';
import { AdminClientProvisioner } from '../clients';

export type AbstractMFAFactorModelModelOptions = V5BaseModelParams<UserMFAFactorResource, AdminClientProvisioner>;

export interface AbstractMFAFactorModelGenerics {
  OPTIONS: AbstractMFAFactorModelModelOptions;
}

export abstract class AbstractMFAFactorModel<
  T extends AbstractMFAFactorModelGenerics = AbstractMFAFactorModelGenerics
> extends V5BaseModel<T['OPTIONS']> {
  abstract name: string;

  constructor(options: T['OPTIONS']) {
    // Comparative resources are based off the user model
    super('mfa-factor', options);
  }

  /**
   * Not needed yet since the authorization is done by userID in Viewer context
   */
  get org_id(): string {
    return '';
  }

  get factorType(): MFAFactor {
    return this.model.factor_type;
  }

  async delete() {
    const client = await this.options.clients.provisionSensitiveUserHubClient();
    await client.deleteMFAFactor({ factor_id: this.id });
  }

  async verify(code: string) {
    const client = await this.options.clients.provisionSensitiveUserHubClient();
    return client.verifyMFAFactor({ factor_id: this.id, code });
  }

  async setAsPreferred() {
    const client = await this.options.clients.provisionSensitiveUserHubClient();
    return client.setPreferredMFAMethod({ factor_id: this.id });
  }
}
